import { Modal } from "antd";
import { registerExclusiveBlockingModal } from "components/Modal/exclusiveBlockingModal";
import { ReactNode } from "react";

interface ModalButtonProps {
    className?: string;
    disabled?: boolean;
}

interface ConfirmModalProps {
    title?: ReactNode;
    content?: ReactNode;
    icon?: ReactNode | null;
    onConfirm: () => void;
    onCancel?: () => void;
    confirmText?: string;
    cancelText?: string;
    cancelButtonProps?: ModalButtonProps;
    confirmButtonProps?: ModalButtonProps;
    className: string;
    centered?: boolean;
    zIndex?: number;
    // When true, this dialog registers as an "exclusive" blocking modal for its
    // whole lifetime (see exclusiveBlockingModal). While it is open, the
    // unsaved-changes navigation guard suppresses its own popover so the two
    // never stack — only one warning dialog is ever shown at a time. Use for
    // blocking data-safety confirmations (e.g. the stale-write conflict dialog).
    exclusive?: boolean;
    // Fires after the dialog has fully closed (antd afterClose). Preserved when
    // `exclusive` is set (the registry release is chained in front of it).
    afterClose?: () => void;
}

export const showConfirmModal = ({
    title,
    content,
    icon = null,
    onConfirm = () => {},
    onCancel = () => {},
    confirmText = "",
    cancelText = "",
    cancelButtonProps,
    confirmButtonProps,
    className,
    centered,
    zIndex,
    exclusive = false,
    afterClose,
}: ConfirmModalProps) => {
    const release = exclusive ? registerExclusiveBlockingModal() : null;
    return Modal.confirm({
        title,
        content,
        icon,
        onOk: onConfirm,
        onCancel,
        okText: confirmText,
        cancelText,
        cancelButtonProps,
        okButtonProps: confirmButtonProps,
        className,
        centered,
        zIndex,
        afterClose: () => {
            release?.();
            afterClose?.();
        },
    });
};
